// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2l05o","footer":"ModalUpdate_footer__1aTub"};